import React, { useState, useEffect, useRef } from "react";
import Notice from "../../components/Notice";
import Bms from "~/images/BMS.png";
import _ from "lodash";
import { search, filterByStatus } from "../../components/Pharmacies/utils";
import PharmacySearch from "../../components/Pharmacies/PharmacySearch";

export default function BmsPharmacyTable(props) {
  const [editing, setEditing] = React.useState(false);
  const [displayConfirmation, setDisplayConfirmation] = React.useState(false);
  const [attestingPharmacies, setAttestingPharmacies] = React.useState([]);
  const [pharmacies, setPharmacies] = React.useState(props.pharmacies);
  const [notice, setNotice] = React.useState({
    kind: "error",
    open: false,
    message: "",
  });
  const [eligibility, setEligibility] = useState(props.eligibility);
  const [searchTerms, setSearchTerms] = useState({ searchQuery: "", filterQuery: [] });

  useEffect(() => {
    filterPharmacies();
  }, [searchTerms]);

  const filterPharmacies = () => {
    if (searchTerms.filterQuery.length > 0) {
      return filterByStatus(pharmacies, searchTerms, eligibility, ["retail", "rems", "camzyos"]);
    } else {
      return search(pharmacies, searchTerms);
    }
  };

  const renderEligibilityTag = (status) => {
    switch (status) {
      case "ELIGIBLE":
        return (
          <div className="badge">
            <div className="badge__indicator badge__indicator--green" />
            ELIGIBLE
          </div>
        );
      case "INELIGIBLE":
        return (
          <div className="badge">
            <div className="badge__indicator badge__indicator--red" />
            INELIGIBLE
          </div>
        );
      case "INELIGIBLE_MISSING_CLAIMS":
        return (
          <div className="badge">
            <div className="badge__indicator badge__indicator--red" />
            INELIGIBLE - MISSING CLAIMS
          </div>
        );
      case "IN_PROCESS":
        return (
          <div className="badge">
            <div className="badge__indicator badge__indicator--green" />
            IN PROCESS
          </div>
        );
      case "AT_RISK":
        return (
          <div className="badge">
            <div className="badge__indicator badge__indicator--orange" />
            AT RISK
          </div>
        );
    }
  };

  const renderPharmacyStatus = (pharmacy) => {
    return renderEligibilityTag(props.eligibility[pharmacy.pharmacy_id].retail);
  };

  const renderRemsPharmacyStatus = (pharmacy) => {
    return renderEligibilityTag(
      props.eligibility[pharmacy.pharmacy_id] && props.eligibility[pharmacy.pharmacy_id].rems
    );
  };

  const renderCamzyosPharmacyStatus = (pharmacy) => {
    return renderEligibilityTag(
      props.eligibility[pharmacy.pharmacy_id] && props.eligibility[pharmacy.pharmacy_id].camzyos
    );
  };

  const renderKrazatiPharmacyStatus = (pharmacy) => {
    return renderEligibilityTag(
      props.eligibility[pharmacy.pharmacy_id] && props.eligibility[pharmacy.pharmacy_id].krazati
    );
  };

  const renderAugtyroPharmacyStatus = (pharmacy) => {
    return renderEligibilityTag(
      props.eligibility[pharmacy.pharmacy_id] && props.eligibility[pharmacy.pharmacy_id].augtyro
    );
  };

  const renderZenbexusPharmacyStatus = (pharmacy) => {
    return renderEligibilityTag(
      props.eligibility[pharmacy.pharmacy_id] && props.eligibility[pharmacy.pharmacy_id].zenbexus
    );
  };

  const renderPharmacies = () => {
    return filterPharmacies().map((pharmacy, i) => {
      return (
        <tr key={i} className="sm">
          <td className="t--md">
            <div className="t--sm t--500">{pharmacy.pharmacy_name}</div>
            <div className="t--sm t--subtitle">{pharmacy.address}</div>
          </td>
          <td className="t--md">{pharmacy.dea}</td>
          <td className="t--md">{renderPharmacyStatus(pharmacy)}</td>
          <td className="t--md">{renderRemsPharmacyStatus(pharmacy)}</td>
          <td className="t--md">{renderCamzyosPharmacyStatus(pharmacy)}</td>
          <td className="t--md">{renderKrazatiPharmacyStatus(pharmacy)}</td>
          <td className="t--md">{renderAugtyroPharmacyStatus(pharmacy)}</td>
          <td className="t--md">{renderZenbexusPharmacyStatus(pharmacy)}</td>
        </tr>
      );
    });
  };
  return (
    <div>
      <div className="table__actionbar table__actionbar--spacebetween">
        <div className="table__actionbar__vertical_stack">
          <PharmacySearch
            searchTerms={searchTerms}
            setSearchTerms={setSearchTerms}
            filterable={true}
          />
        </div>
      </div>

      <div className="table__container" style={{ padding: "0 5px", marginBottom: 50 }}>
        <table className="primary">
          <thead>
            <tr className="sm">
              <th>Pharmacy</th>
              <th>DEA</th>
              <th>Status</th>
              <th>IMiDs</th>
              <th>Camzyos</th>
              <th>Krazati</th>
              <th>Augtyro</th>
              <th>Zenbexus</th>
            </tr>
          </thead>

          <tbody>{renderPharmacies()}</tbody>
        </table>
      </div>
      <Notice details={notice} />
    </div>
  );
}
